import JsonMapper from "@/assets/js/models/helpers/JsonMapper";
import GoogleSheetFieldCollection from "@/assets/js/models/GoogleSheet/GoogleSheetFieldCollection";
import User from "@/assets/js/models/user/User";
import WarehouseCollection from "@/assets/js/models/warehouse/WarehouseCollection";
import StoreCollection from "@/assets/js/models/domain/StoreCollection";
import ProductCollection from "@/assets/js/models/product/ProductCollection";
import SalePageCollection from "@/assets/js/models/salePage/SalePageCollection";
import JsonMappedModel from "@/assets/js/models/helpers/JsonMappedModel";

export default class GoogleSheet extends JsonMappedModel {

    static FROM_ANY_WHERE = 'from_any_where';
    static FROM_STORE = 'from_store';
    static FROM_WAREHOUSE = 'from_warehouse';
    static FROM_SALE_PAGE = 'from_sale_page';
    static FROM_PRODUCT = 'from_product';

    static ACTIVE_STATUS = 'active';
    static INACTIVE_STATUS = 'inactive';

    static id_attribute_name = 'id';
    static name_attribute_name = 'name';
    static user_id_attribute_name = 'user_id';
    static url_attribute_name = 'url';
    static sheet_name_attribute_name = 'sheet_name';
    static orders_from_attribute_name = 'orders_from';
    static fields_attribute_name = 'fields';
    static from_warehouses_attribute_name = 'from_warehouses';
    static from_stores_attribute_name = 'from_stores';
    static from_products_attribute_name = 'from_products';
    static from_sale_pages_attribute_name = 'from_sale_pages';
    static status_attribute_name = 'status';
    static owner_attribute_name = 'owner';
    static created_at_attribute_name = 'created_at';

    #attributes = {
        [GoogleSheet.id_attribute_name]: null,
        [GoogleSheet.name_attribute_name]: null,
        [GoogleSheet.user_id_attribute_name]: null,
        [GoogleSheet.url_attribute_name]: null,
        [GoogleSheet.sheet_name_attribute_name]: null,
        [GoogleSheet.orders_from_attribute_name]: GoogleSheet.FROM_ANY_WHERE,
        [GoogleSheet.fields_attribute_name]: GoogleSheetFieldCollection,
        [GoogleSheet.from_warehouses_attribute_name]: WarehouseCollection,
        [GoogleSheet.from_stores_attribute_name]: StoreCollection,
        [GoogleSheet.from_products_attribute_name]: ProductCollection,
        [GoogleSheet.from_sale_pages_attribute_name]: SalePageCollection,
        [GoogleSheet.status_attribute_name]: GoogleSheet.INACTIVE_STATUS,
        [GoogleSheet.owner_attribute_name]: User,
        [GoogleSheet.created_at_attribute_name]: null,
    }

    constructor(data) {
        super(data);
        this.map(data, this.#attributes)
    }

    static getNameAttributeName() {
        return this.name_attribute_name
    }

    static getStatusAttributeName() {
        return this.status_attribute_name
    }

    static getUrlAttributeName() {
        return this.url_attribute_name
    }

    static getSheetNameAttributeName() {
        return this.sheet_name_attribute_name
    }

    static getOrdersFromAttributeName() {
        return this.orders_from_attribute_name
    }

    static getFieldsAttributeName() {
        return this.fields_attribute_name
    }

    static getFromWarehousesAttributeName() {
        return this.from_warehouses_attribute_name
    }

    static getFromProductsAttributeName() {
        return this.from_products_attribute_name
    }

    static getFromStoreAttributeName() {
        return this.from_stores_attribute_name
    }

    static getFromSalePagesAttributeName() {
        return this.from_sale_pages_attribute_name
    }

    static getOwnerAttributeName() {
        return this.owner_attribute_name
    }

    static getCreatedAtAttributeName() {
        return this.created_at_attribute_name
    }

    getCreatedAt() {
        return this.getAttribute(GoogleSheet.getCreatedAtAttributeName())
    }

    getStatus() {
        return this.getAttribute(GoogleSheet.getStatusAttributeName())
    }

    getOrdersFrom() {
        return this.getAttribute(GoogleSheet.getOrdersFromAttributeName())
    }

    getName() {
        return this.getAttribute(GoogleSheet.getNameAttributeName())
    }

    getUrl() {
        return this.getAttribute(GoogleSheet.getUrlAttributeName())
    }
}